import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import { SUPPORTED_LANGUAGES } from '../i18n';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from './ui/dropdown-menu';

const LanguageSwitcher = ({ variant = 'icon' }) => {
  const { i18n } = useTranslation();
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.resolvedLanguage) || SUPPORTED_LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="language-switcher"
          className={`inline-flex items-center gap-1.5 text-sm rounded-full px-3 h-9 border border-slate-200 bg-white hover:border-slate-300 transition-colors ${variant === 'compact' ? 'px-2' : ''}`}>
          <Globe className="h-4 w-4 text-slate-500" />
          <span className="font-medium text-slate-700">{current.flag} {current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52 max-h-80 overflow-y-auto">
        {SUPPORTED_LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => i18n.changeLanguage(l.code)}
            className="cursor-pointer" data-testid={`lang-${l.code}`}>
            <span className="mr-2">{l.flag}</span>
            <span className="flex-1">{l.label}</span>
            {current.code === l.code && <Check className="h-4 w-4 text-emerald-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
